<template>
  <!-- Con qué versiones se ha reabierto el cálculo de la línea, cuando no son las vigentes. Va junto
       al bloque de la línea porque es de ella de donde salen: sin este aviso, un precio distinto del
       que se ve en la oferta, o igual al de una tarifa que ya no rige, no se explicaría solo. -->
  <div v-if="aviso" class="cdn-state" :class="aviso.clase" role="status">
    <span class="ico">{{ aviso.ico }}</span>
    <div>
      <b>{{ aviso.titulo }}</b>
      <span class="cdn-note">{{ aviso.texto }}</span>
      <button v-if="estado === 'guardadas'" class="cdn-btn" type="button" style="margin-top:8px" @click="$emit('recalcular')">Recalcular con las tarifas vigentes</button>
    </div>
  </div>
</template>

<script>
/**
 * El estado lo decide la calculadora al reabrir (`reapertura.estado`): `guardadas` (se calcula con
 * las versiones de la línea), `vigentes` (se ha pedido recalcular con las de hoy) o `irrecuperables`
 * (las de la línea no se han podido recuperar y se calcula con las de hoy). Con `iguales` no hay nada
 * que contar y no se pinta.
 */
export default {
  props: {
    estado: { type: String, default: '' },
    guardadas: { type: String, default: '' },
    vigentes: { type: String, default: '' },
    precioGuardado: { type: String, default: '' }
  },
  computed: {
    aviso: function () {
      const linea = this.precioGuardado ? 'En la línea hay ' + this.precioGuardado + ' para la 1ª, y se queda así hasta que pulses «Guardar en línea».' : 'La línea no cambia hasta que pulses «Guardar en línea».';
      if (this.estado === 'guardadas') {
        return {
          clase: 'ok', ico: 'i', titulo: 'Calculado con las versiones con las que se guardó la línea',
          texto: this.guardadas + '. Las vigentes son ' + this.vigentes + ', y con ellas el precio puede ser otro.'
        };
      }
      if (this.estado === 'vigentes') {
        return {
          clase: 'ok', ico: 'i', titulo: 'Recalculado con las tarifas vigentes',
          texto: this.vigentes + '; la línea se guardó con ' + this.guardadas + '. ' + linea
        };
      }
      if (this.estado === 'irrecuperables') {
        return {
          clase: 'miss', ico: '!', titulo: 'No se puede reproducir el cálculo con las versiones de la línea',
          texto: 'Se guardó con ' + this.guardadas + ', y esas versiones no se han podido recuperar o ya no calculan con esta pantalla: el resultado está calculado con las vigentes (' + this.vigentes + ') y puede no coincidir con el de la línea. ' + linea
        };
      }
      return null;
    }
  }
};
</script>
